import { ark } from '@ark-ui/react/factory'
import { Popover as ArkPopover } from '@ark-ui/react/popover'
import { title } from '../popover/popover.styles'

export type TitleProps = React.ComponentProps<typeof ark.span>

export function PopoverTitle({ className, ...props }: TitleProps) {
  return (
    <ArkPopover.Title asChild>
      <ark.span {...props} className={title()} />
    </ArkPopover.Title>
  )
}

PopoverTitle.displayName = 'PopoverTitle'
